import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { BaseService } from '../shared/services/base.service';
import { TranslationService } from '../shared/i18n/translation.service';
import { environment } from 'src/environments/environment.prod';

@Injectable({
    providedIn: 'root'
})
export class BranchService extends BaseService<any> {
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
        }),
    };
    API_URLFind = `${environment.apiUrl}/Branch/find`;
    API_URLGetAll = `${environment.apiUrl}/Branch/GetAllBrachesForWebsite`;
    API_URLAdd = `${environment.apiUrl}/Branch`;
    API_URLUpdate = `${environment.apiUrl}/Branch`;
    API_URLDelete = `${environment.apiUrl}/Branch`;
    API_URLGetById = `${environment.apiUrl}/Branch`;
    constructor(@Inject(HttpClient) http: HttpClient, public toastr: ToastrService, public translationServices: TranslationService) {
        super(http, toastr, translationServices);
    }
    getAlForSite(): Observable<any[]> {
        return this.http.get<any[]>(this.API_URLGetAll, this.httpOptions).pipe(
            map((body: any) => body),
            catchError(() => of())
        )
    }
}

